import { AxiosInstance } from 'axios';
import { authRequestMiddleware } from './auth';
import { handleUnauthorizedMiddleware } from './handle-unauthorized';
import { queryParamsMiddleware } from './query-params';

export const setDefaultInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.request.use(queryParamsMiddleware);
  instance.interceptors.request.use(authRequestMiddleware);

  instance.interceptors.response.use(undefined, handleUnauthorizedMiddleware);
};
